/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
import React from 'react'
import { STATIC_IDS } from '../VRMDetails'

import './VRMSection.css'
import TextBox from '@components/base/textBox/TextBox'
import ButtonComponent from '@components/base/button/Button'
import { ReactSVG } from 'react-svg'
import EnableEditIcon from '../../../../../../src/assets/images/vrm_edit_enable.svg'
import DisableEditIcon from '../../../../../../src/assets/images/vrm_edit_disable.svg'
import VRMIcon from '../../../../../../src/assets/images/vrm_Icon.svg'
import { TASK_STATUS } from '@pages/manualReviewTab/constants'

const VRMSection = ({
  label,
  vrmValue,
  isEditing,
  onEditClick,
  onCancelClick,
  onUpdateClick,
  onVrmChange,
  checkFuzzyVRM,
  isVRMDisabled,
  isUpdateDisabled,
  observationDetails,
}) => {
  const BUTTONS = {
    CHECK_FUZZY: {
      fieldValue: 'Check Fuzzy VRM',
      fieldLabel: 'Check Fuzzy VRM',
      variant: 'secondary',
      id: 'btn_checkFuzzyVRM',
      dataTestId: 'btn_checkFuzzyVRM',
      className: 'check-fuzzy-btn',
    },
    CANCEL: {
      fieldValue: 'Cancel',
      fieldLabel: 'Cancel',
      variant: 'secondary',
      id: 'btn_cancelEdit',
      dataTestId: 'btn_cancelEdit',
      className: 'cancel-btn',
    },
    UPDATE: {
      fieldValue: 'Update VRM',
      fieldLabel: 'Update VRM',
      variant: 'primary',
      id: 'btn_updateVRM',
      dataTestId: 'btn_updateVRM',
      className: 'update-btn',
    },
  }

  return (
    <div className="vrm-section">
      <div className="header-row">
        <div className="title-with-icon">
          {/* <span className="vrm-icon" role="img" aria-label="car"></span> */}
          <ReactSVG src={VRMIcon} alt="" className={`vrm-icon`} />
          <h2 className="section-title">{label}</h2>
        </div>
        {observationDetails?.taskStatus !== TASK_STATUS?.DISCARDED &&
          observationDetails?.taskStatus !== TASK_STATUS?.ISSUED && (
            <div
              className={`edit-title ${
                isEditing || isVRMDisabled ? 'editing' : ''
              } ${isVRMDisabled ? 'disabled' : ''}`}
              onClick={!isEditing && !isVRMDisabled ? onEditClick : undefined}
              role={!isEditing && !isVRMDisabled ? 'button' : undefined}
              tabIndex={!isEditing && !isVRMDisabled ? 0 : undefined}
              onKeyDown={(e) => {
                if (
                  !isEditing &&
                  !isVRMDisabled &&
                  (e.key === 'Enter' || e.key === ' ')
                ) {
                  onEditClick()
                }
              }}
              aria-label="Edit VRM"
            >
              <ReactSVG
                src={
                  isEditing || isVRMDisabled ? DisableEditIcon : EnableEditIcon
                }
                alt=""
                className={`vrm-edit-icon`}
              />
              <span className="edit-title-text">{'Edit VRM'}</span>
            </div>
          )}
      </div>
      <div className="vrm-input-row">
        <TextBox
          id={STATIC_IDS?.vrm?.id}
          name={STATIC_IDS?.vrm?.name}
          dataTestId={STATIC_IDS?.vrm?.dataTestId}
          field={{
            fieldValue: STATIC_IDS?.vrm?.id,
            fieldLabel: '',
            className: `colWiseControl vrm-input`,
            disabled: !isEditing,
            multiline: false,
          }}
          value={vrmValue}
          onChangeHandler={onVrmChange}
        />
      </div>
      {observationDetails?.taskStatus !== TASK_STATUS?.DISCARDED &&
        observationDetails?.taskStatus !== TASK_STATUS?.ISSUED && (
          <div className="button-row">
            {!isEditing ? (
              <ButtonComponent
                Field={{
                  ...BUTTONS?.CHECK_FUZZY,
                  disabled: !observationDetails?.isFuzzyVRMEnabled,
                }}
                id={BUTTONS?.CHECK_FUZZY?.id}
                dataTestId={BUTTONS?.CHECK_FUZZY?.dataTestId}
                className={BUTTONS?.CHECK_FUZZY?.className}
                onClickHandler={checkFuzzyVRM}
              />
            ) : (
              <>
                <ButtonComponent
                  Field={BUTTONS?.CANCEL}
                  id={BUTTONS?.CANCEL?.id}
                  dataTestId={BUTTONS?.CANCEL?.dataTestId}
                  className={BUTTONS?.CANCEL?.className}
                  onClickHandler={onCancelClick}
                />
                <ButtonComponent
                  Field={{
                    ...BUTTONS?.UPDATE,
                    disabled: isUpdateDisabled || vrmValue.trim() === '',
                  }}
                  id={BUTTONS?.UPDATE?.id}
                  dataTestId={BUTTONS?.UPDATE?.dataTestId}
                  className={BUTTONS?.UPDATE?.className}
                  onClickHandler={onUpdateClick}
                />
              </>
            )}
          </div>
        )}
    </div>
  )
}

export default VRMSection
